/* eslint-disable max-len */
import PITQuestion from 'images/coin-pages/questions/pit.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const pitPage: ICoinPageData = {
  title: 'coin_762',
  description: 'coin_763',
  // description: 'coin_764',
  h1: (t, _, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Pitbull (PIT)' }) }}
    />
  ),
  questionsBlock: {
    image: PITQuestion,
    questions: [
      {
        title: 'coin_765',
        answer: 'coin_766',
      },
      {
        title: 'coin_767',
        answer: 'coin_768',
      },
      {
        title: 'coin_769',
        answer: 'coin_770',
      },
      {
        title: 'coin_771',
        answer: 'coin_772',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Pitbull'),
    text: [],
    paragraphs: [
      {
        title: 'coin_773',
        text: ['coin_775'],
      },
      {
        title: 'coin_774',
        text: ['coin_776'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/what-is-pitbull-how-to-hold-pit-and-gain-profit/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2023/04/PIT_article-1.png',
        imageAlt: 'Hold PIT & Gain profit',
      },
      blogCards.borrowLikePro,
      blogCards.cryptoCrash,
    ],
  },
}
